module.exports = __webpack_public_path__ + "6c4a0dbc/img/scraper-icon.df6ccde5.svg";